import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import HelpCenter from 'frontend-payments/components/help-center';
import PaymentBillingDetails from 'frontend-payments/components/payment/billing-details';
import PaymentModalStatementOfAccount from 'frontend-payments/components/payment/modal-statement-of-account';
import PaymentPaymentDetails from 'frontend-payments/components/payment/payment-details';
import TransactionTableInvoices from 'frontend-payments/components/transaction/table-invoices';
import type AuthenticatedOverviewController from 'frontend-payments/controllers/authenticated/overview';
import { contextualPageTitle } from 'frontend-utils';

import styles from './overview.module.css';

interface AuthenticatedOverviewSignature {
  Args: {
    controller: AuthenticatedOverviewController;
  };
}

export default class AuthenticatedOverview extends Component<AuthenticatedOverviewSignature> {
  @service declare accountSwitcher: Services['account-switcher'];

  <template>
    {{pageTitle
      (contextualPageTitle
        (t "payments.app.header.overview")
        this.accountSwitcher.currentAccount.name
      )
    }}

    <div class={{styles.container}}>
      <PaymentBillingDetails
        @account={{@controller.account}}
        @isAccountLoading={{@controller.isAccountRequestLoading}}
      />

      <PaymentPaymentDetails
        @account={{@controller.account}}
        @isAccountRequestLoading={{@controller.isAccountRequestLoading}}
        @isTransactionRequestLoading={{@controller.isTransactionRequestLoading}}
        @transactions={{@controller.unpaidTransactions}}
      />

      <section>
        <div class="mb-300 flex justify-between">
          <h3 class="text-emphasis">{{t "payments.invoices"}}</h3>
          <PrismButton
            @buttonType="secondary"
            @isDisabled={{@controller.isAccountRequestLoading}}
            @label={{t "payments.invoice.create_statement_of_account"}}
            @onClick={{@controller.openStatementOfAccountModal}}
          />
        </div>
        <TransactionTableInvoices
          @account={{@controller.account}}
          @isTransactionRequestLoading={{@controller.isTransactionRequestLoading}}
          @onPayNowClick={{@controller.selectPaymentMethodForTransaction}}
          @transactions={{@controller.transactions}}
        />
      </section>
      <section>
        <div class="text-emphasis mb-300">
          <h3>{{t "payments.help_center"}}</h3>
        </div>
        <HelpCenter @accountNumber={{@controller.account.accountNumber}} />
      </section>
    </div>

    {{#if @controller.isStatementOfAccountModalOpen}}
      <PaymentModalStatementOfAccount
        @account={{@controller.account}}
        @onCloseModal={{@controller.closeStatementOfAccountModal}}
      />
    {{/if}}
  </template>
}
